export default __webpack_public_path__ + "static/media/zenStamp.debf016d.png";